import { APIRoute } from '@/modules/utils'
import { PureObject } from 'emt-library'
import { ConnectedUserAnimal } from '@/dataV3/Animal/ConnectedUserAnimal'

export type Body = Omit<PureObject<ConnectedUserAnimal>, 'id' | 'acquisitionStatus'>

export type Response = ConnectedUserAnimal

export const Route: APIRoute = {
  method: 'POST',
  path: '/members/animals',
}
